import {
  Component,
  DoCheck,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {
  ActivityUtilities,
  DataService,
  ValidationService,
  WorkflowContextService,
  WorkflowService
} from 'src/app/services';
import {
  ActivitiesBasedOnCategoryData,
  InlineApplicationsCardData,
  JanusApplicationSummaryData
} from './inline-applications-card.model';
import { finalize, Subject, takeUntil } from 'rxjs';
import { svgs } from 'src/assets/export.assets';
import { ApplicationStatus, WorkflowCategoryVM } from 'src/app/models';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { WorkflowApplicationsJanusService } from '../../workflow-applications-janus.service';
import { JsonNetDecycle } from 'src/app/services/utilities/json-net-decycle';
import {
  Activity,
  ActivityModel,
  ActivityStatus
} from 'src/app/models/activities';
import { ActivityViewComponent } from 'src/app/components/workflow/activities/activity-editor/activity-view/activity-view.component';
// Added by Amisha on 2026-08-12.
// Reason: open the reusable sharing dialog for an individual inline activity.
import { ShareActivityComponent } from 'src/app/components/workflow/share-activity/share-activity.component';

@Component({
  selector: 'app-inline-applications-card',
  standalone: false,
  templateUrl: './inline-applications-card.component.html',
  styleUrl: './inline-applications-card.component.scss'
})
export class InlineApplicationsCardComponent implements OnInit, OnDestroy, DoCheck {
  @Input() applicationId: string;
  @Input() applicationDate: string;
  @Input() applicationStatus: string;
  @Input() applicationNo: string;
  @Input({ required: false }) onlyAttachments: boolean;
  @Input({ required: false }) onlyNotes: boolean;
  isChildApplication: boolean = false;
  childApplicationId: string | null = null;
  parentApplicationDetails = {
    name: '',
    number: ''
  };
  @Output() notesChanged = new EventEmitter<{
    applicationId: string;
    unreadNotes: number;
    totalNotes: number;
  }>();
  @Output() attachmentChanged = new EventEmitter<{
    applicationId: string;
    unreadAttachments: number;
    totalAttachments: number;
  }>();
  private destroy$ = new Subject<void>();

  @ViewChildren(ActivityViewComponent)
  private activityViewComponents!: QueryList<ActivityViewComponent>;
  // Added by Amisha on 2026-08-12.
  // Reason: control activity-wise sharing from each inline activity header.
  @ViewChild(ShareActivityComponent)
  private shareActivityComponent!: ShareActivityComponent;

  // Added by Amisha on 2026-09-22.
  // Reason: control the mobile category strip, expose its scroll boundaries, and
  // bring categories selected from shortcut icons into the visible viewport.
  private categoryListElement?: ElementRef<HTMLElement>;
  private lastActiveCategoryId = '';
  private readonly mobileCategoryBreakpoint = 600;
  canScrollCategoriesLeft = false;
  canScrollCategoriesRight = false;

  @ViewChild('categoryListContainer')
  set categoryListContainer(element: ElementRef<HTMLElement> | undefined) {
    this.categoryListElement = element;
    this.scheduleActiveCategoryScroll();
  }

  sharingActivityDataId: string | null = null;

  inlineApplicationDetails: InlineApplicationsCardData = {
    categoryLoadingMsg: '',
    categoriesFetchError: '',
    isCategoryFetching: false,
    applicationCategories: [],
    activeApplicationCategory: {
      id: '',
      name: '',
      hasInProgressActivities: false
    },
    activitiesBasedOnCategory: [],
    isfetchingActivities: false,
    errorFetchingActivities: '',
    isTestApplication: true,
    showAppView: false,
    showAppSummary: false,
    appViewDetails: undefined,
    actions: [],
    applicationSummaryDetails: {
      workflowId: '',
      application: null
    },
    applicationStatusCode: 0,
    paramCategoryName: null,
    fees: [],
    hasFees: false,
    combinedApplicationNumber:'',
    submitter:null,
    startedOn:'',
    workflowId:'',
    workflowVersionId:'',
    workflowName:'',
    applicationNumber:'',
    linkedApplications:[]
  };
  janusApplicationSummaryDetails: JanusApplicationSummaryData = {
    application: null,
    fees: [],
    totalPaid: 0,
    submitter: null,
    completedActivities: [],
    registrationId: '',
    client: null,
    workflowType: null,
    workflowId: '',
    workflowVersionId: ''
  };

  inlineApplicationStaticDetails = {
    errorIcon: svgs.errorIcon.name,
    downArrowIcon: svgs.keyboardArrowDownIcon.name,
    upArrowIcon: svgs.keyboardUpArrowIcon.name,
    relateToPermitIcon: svgs.relateToPermitIcon.name
  };
  isLinkedApplication:string;
  showOnlyAttachmentsCategory:boolean;
  showOnlyNotesCategory:boolean;


  constructor(
    private workflowService: WorkflowService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private context: WorkflowContextService,
    private workflowApplicationsJanusSvc: WorkflowApplicationsJanusService,
    private dataSvc: DataService
  ) {}

  ngOnInit(): void {
    this.workflowApplicationsJanusSvc.data$.subscribe((data)=>{
      this.inlineApplicationDetails.linkedApplications = data.linkedApplications
    })
    this.workflowApplicationsJanusSvc.data$
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        if (data.consolidatedInspection.activity !== null) {
          const idx = this.inlineApplicationDetails.activitiesBasedOnCategory.findIndex(
            activity =>
              activity.activity.activityId ===
              data.consolidatedInspection.activity.id
          );
          if (idx >= 0) {
            if (data.consolidatedInspection.processWay === 'Submit') {
              this.submitActivity(
                data.consolidatedInspection.activity,
                idx,
                true
              );
            } else if (data.consolidatedInspection.processWay === 'Save') {
              this.saveActivity(
                data.consolidatedInspection.activity,
                idx,
                true
              );
            }

            this.workflowApplicationsJanusSvc.setData({
              ...this.workflowApplicationsJanusSvc.getData(),
              consolidatedInspection: {
                activity: null,
                processWay: 'None'
              }
            });
          }
        }
      });
    this.workflowApplicationsJanusSvc.data$
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        if (data.runSubmitForCategoryActivityDataId) {
          const paymentActivityIndex = this.inlineApplicationDetails.activitiesBasedOnCategory.findIndex(
            activity =>
              activity.activity?.activity &&
              activity.activity.activity?.activityDataId ===
                data.runSubmitForCategoryActivityDataId
          );

          if (paymentActivityIndex) {
            const paymentActivity = this.inlineApplicationDetails
              .activitiesBasedOnCategory[paymentActivityIndex].activity
              .activity;
            this.submitActivity(paymentActivity, paymentActivityIndex);
          }
          this.workflowApplicationsJanusSvc.setData({
            ...this.workflowApplicationsJanusSvc.getData(),
            runSubmitForCategoryActivityDataId: null
          });
        }
        if (data.reRunCurrentInlineActivity) {
          const currentActivityIndex = this.inlineApplicationDetails.activitiesBasedOnCategory.findIndex(
            activity =>
              activity.activity?.activity &&
              (activity.activity?.activityId ===
                data.reRunCurrentInlineActivity ||
                activity.activity?.activityDataId ===
                  data.reRunCurrentInlineActivity)
          );
          if (currentActivityIndex >= 0) {
            // re-run current activity api
            this.fetchCurrentActivity(currentActivityIndex);
          }
          this.workflowApplicationsJanusSvc.setData({
            ...this.workflowApplicationsJanusSvc.getData(),
            reRunCurrentInlineActivity: null
          });
        }
      });
    this.isChildApplication =this.route.snapshot.queryParamMap.get('isChild') !== null ? true : false;
    this.childApplicationId = this.route.snapshot.queryParamMap.get('cid');
    this.isLinkedApplication = this.route.snapshot.queryParamMap.get(
      'isLinkedApp'
    );

    this.showOnlyAttachmentsCategory =
      this.onlyAttachments === true ||
      this.route.snapshot.queryParamMap.get('onlyAttachments') === '1';
    this.showOnlyNotesCategory =
      this.onlyNotes === true ||
      this.route.snapshot.queryParamMap.get('onlyNotes') === '1';
    if (this.route.snapshot.queryParamMap.get('onlyAttachments') === '1') {
      this.onlyAttachments = true;
    }
    if (this.route.snapshot.queryParamMap.get('onlyNotes') === '1') {
      this.onlyNotes = true;
    }
    

    this.route.queryParamMap
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        // fetch id from query params
        const paramApplicationId = params.get('id');
        this.isChildApplication = params.get('isChild') !== null ? true : false;
        if(this.isChildApplication === true){
          this.childApplicationId = params.get('cid');
        }
        // check if id is present then only run
        if (paramApplicationId && paramApplicationId === this.applicationId) {
          // fetch application status code
          this.inlineApplicationDetails.applicationStatusCode =
            ApplicationStatus[
              this.applicationStatus as keyof typeof ApplicationStatus
            ];
          if (!this.inlineApplicationDetails.applicationStatusCode) {
            const currentPage = this.route.snapshot.queryParamMap.get('p');
            this.context.applicationViewType$.emit('none');
            this.router.navigate([], {
              relativeTo: this.route,
              queryParams: {
                p: currentPage || 1
              },
              queryParamsHandling: 'replace'
            });
            this.toastr.error(
              'The application status is invalid or unavailable. Please refresh and try again.'
            );
            return;
          }
          const onlyAttachment = params.get('onlyAttachments');
          if (onlyAttachment && onlyAttachment === '1') {
            this.onlyAttachments = true;
            const attachmentCategory = {
              name: 'Attachments',
              staticCategoryType: 'attachments',
              id: '1',
              hasInProgressActivities: false
            };
            this.inlineApplicationDetails.applicationCategories = [
              attachmentCategory
            ];
            this.inlineApplicationDetails.activeApplicationCategory = attachmentCategory;
            return;
          }
          const onlyNote = params.get('onlyNotes');
          if (onlyNote && onlyNote === '1') {
            this.onlyNotes = true;
            const notesCategory = {
              name: 'Notes',
              staticCategoryType: 'notes',
              id: '1',
              hasInProgressActivities: false
            };
            this.inlineApplicationDetails.applicationCategories = [
              notesCategory
            ];
            this.inlineApplicationDetails.activeApplicationCategory = notesCategory;
            return;
          }
          // set view to inline
          this.context.applicationViewType$.emit('inline');
          // check if child application need to be rendered
          // const isChildApplication = params.get('isChild');
          // if(isChildApplication === '1'){
          //   this.inlineApplicationDetails.showAppView = true;
          //   const paramChildId = params.get('cid');
          //   this.context.applicationId$.emit(paramChildId);
          //   return;
          // }

          const isLinkedApplication = params.get('isLinkedApp');
          if (isLinkedApplication === '1') {
            this.inlineApplicationDetails.showAppView = true;
            const paramLinkedId = params.get('cid');
            this.context.applicationId$.emit(paramLinkedId);
            return;
          }
          if (this.isChildApplication) {
            this.context.applicationId$.emit(this.childApplicationId);
          } else {
            this.context.applicationId$.emit(this.applicationId);
          }

          // fetch showAppView from query params
          const paramShowAppView = params.get('showAppView');
          this.inlineApplicationDetails.paramCategoryName = params.get('c');
          if (
            paramShowAppView === '0' &&
            this.inlineApplicationDetails.applicationCategories.length > 0 &&
            this.inlineApplicationDetails.paramCategoryName
          ) {
            // setActive category
            const getActiveCategoryIndex = this.inlineApplicationDetails.applicationCategories.findIndex(
              cat =>
                cat.name.toLowerCase() ===
                this.inlineApplicationDetails.paramCategoryName.toLowerCase()
            );
            if (getActiveCategoryIndex >= 0) {
              this.inlineApplicationDetails.errorFetchingActivities = '';
              this.inlineApplicationDetails.activeApplicationCategory = this.inlineApplicationDetails.applicationCategories[
                getActiveCategoryIndex
              ];

              this.fetchActivitiesBasedOnCategory(
                this.inlineApplicationDetails.activeApplicationCategory.id
              );
            }
          } else if (paramShowAppView === '1') {
            // && (params.get('workflowId') && params.get('activityDataId') && params.get('isTest'))
            this.inlineApplicationDetails.showAppView = true;
          } else if (paramShowAppView === '2') {
            this.inlineApplicationDetails.showAppSummary = true;
          } else {
            if (this.isChildApplication) {
              this.fetchCategoriesBasedOnApplicationId(
                this.childApplicationId,
                this.applicationDate,
                1
              );
            } else {
              this.fetchCategoriesBasedOnApplicationId(
                this.applicationId,
                this.applicationDate,
                this.inlineApplicationDetails.applicationStatusCode
              );
            }
          }
        }
      });
  }

  // Added by Amisha on 2026-09-22.
  // Reason: category selection can change from a table shortcut, query parameter,
  // or category button, so react to the shared active-category state in every path.
  ngDoCheck(): void {
    // Updated by Amisha on 2026-09-22.
    // Reason: automatic category scrolling is a mobile-only enhancement and must
    // not alter the existing desktop category-row position.
    if (!this.isMobileCategoryNavigation()) return;

    const activeCategoryId = this.inlineApplicationDetails.activeApplicationCategory?.id || '';
    if (activeCategoryId && activeCategoryId !== this.lastActiveCategoryId) {
      this.lastActiveCategoryId = activeCategoryId;
      this.scheduleActiveCategoryScroll();
    }
  }

  // Added by Amisha on 2026-09-22.
  // Reason: provide the same left/right mobile navigation used by other horizontally
  // scrollable tab rows while keeping the selected category visible.
  scrollCategories(direction: 'left' | 'right'): void {
    if (!this.isMobileCategoryNavigation()) return;

    const container = this.categoryListElement?.nativeElement;
    if (!container) return;

    container.scrollBy({
      left: direction === 'left' ? -Math.max(120, container.clientWidth * 0.7) : Math.max(120, container.clientWidth * 0.7),
      behavior: 'smooth'
    });
  }

  onCategoryListScroll(): void {
    if (!this.isMobileCategoryNavigation()) return;
    this.updateCategoryScrollControls();
  }

  private scheduleActiveCategoryScroll(): void {
    if (!this.isMobileCategoryNavigation()) return;

    setTimeout(() => {
      this.scrollActiveCategoryIntoView();
      this.updateCategoryScrollControls();
    });
  }

  private scrollActiveCategoryIntoView(): void {
    const container = this.categoryListElement?.nativeElement;
    const activeCategory = container?.querySelector<HTMLElement>(
      '.janus-active-category-list-button'
    );
    if (!container || !activeCategory) return;

    const containerBounds = container.getBoundingClientRect();
    const categoryBounds = activeCategory.getBoundingClientRect();

    if (categoryBounds.left < containerBounds.left) {
      container.scrollBy({
        left: categoryBounds.left - containerBounds.left - 8,
        behavior: 'smooth'
      });
    } else if (categoryBounds.right > containerBounds.right) {
      container.scrollBy({
        left: categoryBounds.right - containerBounds.right + 8,
        behavior: 'smooth'
      });
    }
  }

  private updateCategoryScrollControls(): void {
    const container = this.categoryListElement?.nativeElement;
    if (!container) {
      this.canScrollCategoriesLeft = false;
      this.canScrollCategoriesRight = false;
      return;
    }

    const maximumScrollLeft = container.scrollWidth - container.clientWidth;
    this.canScrollCategoriesLeft = container.scrollLeft > 1;
    this.canScrollCategoriesRight = container.scrollLeft < maximumScrollLeft - 1;
  }

  private isMobileCategoryNavigation(): boolean {
    return window.innerWidth <= this.mobileCategoryBreakpoint;
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.onlyAttachments = false;
    this.onlyNotes = false;
  }

  fetchInlineApplicationSummary() {
    const appId = this.isChildApplication
      ? this.childApplicationId
      : this.applicationId;
    this.dataSvc
      // fixCurrentActivities: false — this chip renders a read-only summary and never
      // processes activities off the returned payload, so the server's FixCurrentActivities
      // reconciliation pass is pure overhead here.
      .getApplicationSummary(appId, true, true, false)
      .subscribe(appSummary => {
        if (appSummary) {
          this.janusApplicationSummaryDetails = {
            application: appSummary.application,
            fees: appSummary.fees,
            totalPaid: appSummary.totalPaid,
            submitter: appSummary.submitter,
            completedActivities: appSummary.completedActivities,
            registrationId: appSummary.registrationId,
            client: appSummary.client,
            workflowType: appSummary.workflowType,
            workflowId: appSummary.workflowId,
            workflowVersionId: appSummary.workflowVersionId
          };

          this.context.isTestApplication$.emit(
            appSummary.application.isTestApplication
          );
        }
      });
  }

  fetchCategoriesBasedOnApplicationId = (
    appId: string,
    appDate: string,
    appStatusCode: ApplicationStatus
  ) => {
    this.inlineApplicationDetails.activitiesBasedOnCategory = [];

    if ((!this.isChildApplication && !appDate) || appDate === '') {
      // if no app data and status is in progress then only open app view else open summary view for all other status
      if (appStatusCode === 1 || appStatusCode === 0) {
        // no appdate and application is in progress
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            activityDataId: null,
            isTest: null,
            workflowId: null,
            c: null,
            showAppView: 1
          },
          queryParamsHandling: 'merge'
        });
      } else {
        setTimeout(()=>{
            if (
              !this.isLinkedApplication &&
              !this.showOnlyAttachmentsCategory &&
              !this.showOnlyNotesCategory
            ) {
              this.fetchInlineApplicationSummary();
            }
          },500)
        // summary view for all status except in progress
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            activityDataId: null,
            isTest: null,
            workflowId: null,
            c: null,
            showAppView: 2
          },
          queryParamsHandling: 'merge'
        });
      }
      return;
    } else {
      this.inlineApplicationDetails.isCategoryFetching = true;
      this.inlineApplicationDetails.categoryLoadingMsg =
        'Loading application details...';
      this.inlineApplicationDetails.activeApplicationCategory = {
        id: '',
        name: '',
        hasInProgressActivities: false
      };
      setTimeout(() => {
        if (this.inlineApplicationDetails.isCategoryFetching === true) {
          this.inlineApplicationDetails.categoryLoadingMsg =
            'Still working on it. This may take a few more moments...';
        }
      }, 3000);
      this.inlineApplicationDetails.categoriesFetchError = '';
      this.workflowService
        .getCurrentActivity(appId)
        .pipe(
          finalize(() => {
            this.inlineApplicationDetails.isCategoryFetching = false;
          })
        )
        .subscribe({
          next: response => {
            this.inlineApplicationDetails.linkedApplications = response.linkedApplications;
                    this.workflowApplicationsJanusSvc.setData({
              ...this.workflowApplicationsJanusSvc.getData(),
              linkedApplications:response.linkedApplications
            });
            this.inlineApplicationDetails.startedOn = response.startedOn.toString().toLowerCase().split('t')[0];
            this.inlineApplicationDetails.submitter = response.submitter;
            this.inlineApplicationDetails.combinedApplicationNumber = response.combinedApplicationNumber;
            this.inlineApplicationDetails.workflowId = response.workflowId;
            this.inlineApplicationDetails.workflowName = response.workflowName;
            this.inlineApplicationDetails.workflowVersionId = response.workflowVersionId;
            this.inlineApplicationDetails.applicationNumber = response.applicationNumber

            const pa = response.navigationItems[0];
            this.parentApplicationDetails = {
              name: pa.activityLabel,
              number: pa.applicationNumber
            };

            this.inlineApplicationDetails.fees = response.fees;
            this.inlineApplicationDetails.hasFees = response.hasFees;
            this.inlineApplicationDetails.currentActivity = response.activity;
            this.context.isTestApplication$.emit(response.isTestApplication);

            if (
              (this.isChildApplication && !response?.applicationSubmittedOn) ||
              response.applicationCategories === undefined ||
                response.applicationCategories.length === 0
            ) {
              setTimeout(() => {
                this.workflowApplicationsJanusSvc.setData({
                  ...this.workflowApplicationsJanusSvc.getData(),
                  inlineApplicationSummaryDetails: {
                    ...this.workflowApplicationsJanusSvc.getData()
                      .inlineApplicationSummaryDetails,
                    categoriesDefined: false
                  }
                });
              });
              if (this.isChildApplication) {
                this.router.navigate([], {
                  relativeTo: this.route,
                  queryParams: {
                    activityDataId: response.activity.activityDataId,
                    isTest: response.isTestApplication,
                    workflowId: response.workflowId,
                    c: null,
                    showAppView: 1
                  },
                  queryParamsHandling: 'merge'
                });
              } else {
                // status -> COMPLETED,VOIDED, REJECTED, DISCARDED, EXPIRED, LOCKED, WITHDRAWEN - (category chip not defined)
                if (appStatusCode !== 0 && appStatusCode !== 1) {
                  // summary view open related code
                  this.router.navigate([], {
                    relativeTo: this.route,
                    queryParams: {
                      activityDataId: null,
                      isTest: null,
                      workflowId: null,
                      c: null,
                      showAppView: 2
                    },
                    queryParamsHandling: 'merge'
                  });
                } else {
                  // status -> INPROGRESS - (category chip  not defined)
                  // app view open related code
                  this.router.navigate([], {
                    relativeTo: this.route,
                    queryParams: {
                      activityDataId: response.activity.activityDataId,
                      isTest: response.isTestApplication,
                      workflowId: response.workflowId,
                      c: null,
                      showAppView: 1
                    },
                    queryParamsHandling: 'merge'
                  });
                }
              }

              return;
            }

            this.inlineApplicationDetails.isTestApplication =
              response.isTestApplication;
            if (this.inlineApplicationDetails.applicationStatusCode !== 1) {
              this.inlineApplicationDetails.applicationCategories = response.applicationCategories.filter(
                cat => cat?.staticCategoryType !== 'submit'
              );
            } else {
              this.inlineApplicationDetails.applicationCategories =
                response.applicationCategories;
            }

            setTimeout(() => {
              this.workflowApplicationsJanusSvc.setData({
                ...this.workflowApplicationsJanusSvc.getData(),
                inlineApplicationSummaryDetails: {
                  ...this.workflowApplicationsJanusSvc.getData()
                    .inlineApplicationSummaryDetails,
                  categoriesDefined: true
                }
              });
            });
            this.inlineApplicationDetails.applicationCategories.push({
              id: '-1',
              name: 'View-Application',
              hasInProgressActivities: false,
              staticCategoryType: 'view-application'
            });

            if (this.inlineApplicationDetails.paramCategoryName) {
              const goToCategoryIndex = this.inlineApplicationDetails.applicationCategories.findIndex(
                cat =>
                  cat.name.toLowerCase() ===
                  this.inlineApplicationDetails.paramCategoryName.toLowerCase()
              );
              this.inlineApplicationDetails.activeApplicationCategory = this.inlineApplicationDetails.applicationCategories[
                goToCategoryIndex
              ];
              this.fetchActivitiesBasedOnCategory(
                this.inlineApplicationDetails.activeApplicationCategory.id
              );
            } else {
              // status -> COMPLETED,VOIDED, REJECTED, DISCARDED, EXPIRED, LOCKED, WITHDRAWEN - (category chip defined)
              if (appStatusCode !== 0 && appStatusCode !== 1) {
                this.router.navigate([], {
                  relativeTo: this.route,
                  queryParams: {
                    c: this.inlineApplicationDetails.applicationCategories[
                      this.inlineApplicationDetails.applicationCategories
                        .length - 1
                    ].name.toLowerCase(),
                    activityDataId: null,
                    isTest: null,
                    workflowId: null,
                    showAppView: 0
                  },
                  queryParamsHandling: 'merge'
                });
              } else {
                // status -> INPROGRESS - (category chip  defined)
                //  go to category where action is required
                for (
                  let i = 0;
                  i <
                  this.inlineApplicationDetails.applicationCategories.length;
                  i++
                ) {
                  if (
                    this.inlineApplicationDetails.applicationCategories[i]
                      .hasInProgressActivities === true
                  ) {
                    this.router.navigate([], {
                      relativeTo: this.route,
                      queryParams: {
                        c: this.inlineApplicationDetails.applicationCategories[
                          i
                        ].name.toLowerCase(),
                        activityDataId: null,
                        isTest: null,
                        workflowId: null,
                        showAppView: 0
                      },
                      queryParamsHandling: 'merge'
                    });
                    return;
                  }
                }
                // if no action reuired categories then go to submit category
                this.router.navigate([], {
                  relativeTo: this.route,
                  queryParams: {
                    c: this.inlineApplicationDetails.applicationCategories[0].name.toLowerCase(),
                    activityDataId: null,
                    isTest: null,
                    workflowId: null,
                    showAppView: 0
                  },
                  queryParamsHandling: 'merge'
                });
              }
            }
          },
          error: _err => {
            this.inlineApplicationDetails.categoriesFetchError =
              'Some error occurred while fetching details';
          }
        });
    }
  };
  onParentApplicationInChildApplicationHeaderClick = () => {
    // go to parent application
    const currentId = this.route.snapshot.queryParamMap.get('id');
    const currentPage = this.route.snapshot.queryParamMap.get('p');
    const source = this.route.snapshot.queryParamMap.get('s');
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        p: currentPage,
        s: source
      },
      queryParamsHandling: 'replace'
    });

    setTimeout(() => {
      this.router.navigate([], {
        queryParams: {
          id: currentId,
          p: currentPage,
          s: source
        },
        queryParamsHandling: 'replace'
      });
      this.workflowApplicationsJanusSvc.setData({
        ...this.workflowApplicationsJanusSvc.getData(),
        scrollToExpandedRow: true
      });
    }, 500);
  };
  onRelateToPermitIconClick = () => {
    // open relateToPermit view true
    this.workflowApplicationsJanusSvc.setData({
      ...this.workflowApplicationsJanusSvc.getData(),
      showRelateToPermitView: true,
      linkedApplications:this.inlineApplicationDetails.linkedApplications
    });
  };

  // no need to call start application over here ->
  // we have all data needed in getCurrentActivity called above ->
  // just call app view component
  getCategoryListButtonData = (category: WorkflowCategoryVM) => {
    return {
      text: category.name,
      onClick: () => {
        this.inlineApplicationDetails.activeApplicationCategory = category;
        this.inlineApplicationDetails.activitiesBasedOnCategory = [];
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            c: this.inlineApplicationDetails.activeApplicationCategory.name.toLowerCase()
          },
          queryParamsHandling: 'merge'
        });
      }
    };
  };

  fetchActivitiesBasedOnCategory = (id: string) => {
    if(this.inlineApplicationDetails.activeApplicationCategory?.staticCategoryType === 'view-application'){
      this.inlineApplicationDetails.activitiesBasedOnCategory = [];
      if (
              !this.isLinkedApplication &&
              !this.showOnlyAttachmentsCategory &&
              !this.showOnlyNotesCategory
            ) {
              this.fetchInlineApplicationSummary();
            }
      return;
    }
    this.inlineApplicationDetails.isfetchingActivities = true;
    const appId = this.isChildApplication
      ? this.childApplicationId
      : this.applicationId;
    this.workflowService
      .getCurrentApplicationCategoryActivities(appId, id)
      .pipe(
        finalize(() => {
          this.inlineApplicationDetails.isfetchingActivities = false;
        })
      )
      .subscribe({
        next: response => {
          this.context.applicationViewType$.emit('inline');
          if (
            this.inlineApplicationDetails.activeApplicationCategory
              ?.staticCategoryType &&
            response.length === 0
          ) {
            return;
          }
          if (response.length === 0) {
            this.inlineApplicationDetails.errorFetchingActivities =
              'Please complete the previous or dependent activity first to proceed with this one.';
          }
          this.inlineApplicationDetails.activitiesBasedOnCategory = response.map(
            fetchedCategoryActivity => {
              let activityInstance = null;

              if (fetchedCategoryActivity?.activity) {
                activityInstance = ActivityUtilities.convertActivitiesJsonToClasses(
                  [fetchedCategoryActivity.activity]
                )[0];
              }

              return {
                activity: {
                  ...fetchedCategoryActivity,
                  activity: activityInstance
                },

                form: activityInstance
                  ? new UntypedFormGroup(
                      ValidationService.createValidationGroup(activityInstance),
                      {
                        updateOn: 'blur'
                      }
                    )
                  : new UntypedFormGroup({}),

                isActivityAccordionOpen:
                  fetchedCategoryActivity?.status === 1 && activityInstance
                    ? true
                    : false,

                isFetching: false,
                errorFetching: '',
                isSaving: false,
                isSubmitting: false,

                isActionRequired:
                  fetchedCategoryActivity?.status === 1 ? true : false,

                submitBtnTitle:
                  fetchedCategoryActivity?.status === 1 ? 'SUBMIT' : 'UPDATE',

                showSaveBtn:
                  fetchedCategoryActivity?.activity?.showSaveButton === true &&
                  fetchedCategoryActivity?.status === 1
                    ? true
                    : false,
                showSubmitButton:
                  fetchedCategoryActivity?.activity?.showProcessButton === true
                    ? true
                    : false
              };
            }
          );
        },
        error: _err => {
          this.inlineApplicationDetails.errorFetchingActivities =
            'some error occured while fetching activities based on category';
        }
      });
  };

  getActivityAccordionClick = (
    template: TemplateRef<any>,
    toggle: 'open' | 'close',
    activity: ActivitiesBasedOnCategoryData,
    index: number
  ) => {
    return {
      text: template,
      onClick: () => {
        if (toggle === 'close') {
          this.inlineApplicationDetails.activitiesBasedOnCategory[
            index
          ].isActivityAccordionOpen = false;
        } else if (toggle === 'open') {
          if (
            this.inlineApplicationDetails.activitiesBasedOnCategory[index]
              .activity?.activity
          ) {
            this.inlineApplicationDetails.activitiesBasedOnCategory[
              index
            ].isActivityAccordionOpen = true;
          } else {
            this.inlineApplicationDetails.activitiesBasedOnCategory[
              index
            ].isActivityAccordionOpen = true;
            this.inlineApplicationDetails.activitiesBasedOnCategory[
              index
            ].isFetching = true;
            const activityDataId = this.inlineApplicationDetails
              .activitiesBasedOnCategory[index].activity.activityDataId;
            const appId = this.isChildApplication
              ? this.childApplicationId
              : this.applicationId;
            this.workflowService
              .navigateToActivity(appId, activityDataId)
              .pipe(
                finalize(() => {
                  this.inlineApplicationDetails.activitiesBasedOnCategory[
                    index
                  ].isFetching = false;
                })
              )
              .subscribe({
                next: response => {
                  const activityInstance = ActivityUtilities.convertActivitiesJsonToClasses(
                    [response.activity]
                  )[0];

                  this.inlineApplicationDetails.activitiesBasedOnCategory[
                    index
                  ].activity.activity = activityInstance;

                  this.inlineApplicationDetails.activitiesBasedOnCategory[
                    index
                  ].form = new UntypedFormGroup(
                    ValidationService.createValidationGroup(activityInstance),
                    {
                      updateOn: 'blur'
                    }
                  );
                },
                error: _err => {
                  this.inlineApplicationDetails.activitiesBasedOnCategory[
                    index
                  ].errorFetching = 'error occured while fetching activity';
                }
              });
          }
        }
      }
    };
  };

  private validateAndPersistActivity(
    index: number,
    disableValidation: boolean = false
  ): Promise<boolean> {
    if (disableValidation === true) {
      return Promise.resolve(true);
    }
    const activityDetails = this.inlineApplicationDetails
      .activitiesBasedOnCategory[index];

    if (!activityDetails?.form) {
      return Promise.resolve(false);
    }

    // Trigger validation UI
    activityDetails.form.markAllAsTouched();
    activityDetails.form.updateValueAndValidity();

    // Validate required uploads (not covered by reactive form validation)
    const hasUploadErrors = this.validateRequiredUploads(index);

    if (activityDetails.form.invalid || hasUploadErrors) {
      this.scrollToFirstInvalidField(index);
      this.toastr.error('Please correct the validation errors.');
      return Promise.resolve(false);
    }

    // Find the corresponding ActivityViewComponent
    const viewComponent = this.activityViewComponents.toArray()[index];
    if (viewComponent) {
      return viewComponent.persistChildComponent().then(() => true);
    }

    return Promise.resolve(true);
  }

  private validateRequiredUploads(index: number): boolean {
    // Target the nth category-activity-container — the actual wrapper in the DOM
    var wrapper = document.querySelectorAll('.category-activity-container')[
      index
    ];
    if (!wrapper) {
      wrapper = document.querySelector('.category-activity-container');
    }
    if (!wrapper) return false;

    let hasMissingUploads = false;

    // Each wm-data-entity-input is one field — find ones that contain a wm-upload
    const dataEntityInputs = wrapper.querySelectorAll('wm-data-entity-input');

    dataEntityInputs.forEach((entityInput: Element) => {
      const firstDiv = entityInput.querySelector('div');
      if (firstDiv) {
        const style = window.getComputedStyle(firstDiv as Element);
        if (style && style.display === 'none') {
          entityInput.remove();
          return;
        }
      }

      const formEl = entityInput.querySelector('form');
      if (!formEl) return;

      const wmDeLabel = formEl.querySelector('wm-de-label');
      const wmUpload = formEl.querySelector('wm-upload');

      // Only process fields that have both a label and an upload component
      if (!wmDeLabel || !wmUpload) return;

      const hasAsterisk = wmDeLabel.textContent?.includes('*');
      if (!hasAsterisk) return;

      const listItems = wmUpload.querySelectorAll('.list-group-item');
      const fileInput = wmUpload.querySelector<HTMLInputElement>(
        'input[type="file"]'
      );

      if (listItems.length === 0) {
        // No files uploaded — inject error
        hasMissingUploads = true;

        if (fileInput?.parentElement) {
          let errorSpan = fileInput.parentElement.querySelector<
            HTMLSpanElement
          >('.upload-required-error');
          if (!errorSpan) {
            errorSpan = document.createElement('span');
            errorSpan.className = 'upload-required-error';
            errorSpan.textContent = 'Required';
            errorSpan.style.color = 'red';
            errorSpan.style.display = 'block';
            errorSpan.style.marginTop = '4px';
            errorSpan.style.marginLeft = '0px';
            const uploadButton =
              fileInput.parentElement.querySelector('.upload-button') ||
              fileInput.parentElement.querySelector('wm-common-button') ||
              fileInput.parentElement.querySelector('button');

            if (uploadButton) {
              const wrapper = document.createElement('div');
              wrapper.style.display = 'flex';
              wrapper.style.flexDirection = 'column';
              wrapper.style.alignItems = 'flex-start';

              uploadButton.parentNode?.insertBefore(wrapper, uploadButton);
              wrapper.appendChild(uploadButton);
              wrapper.appendChild(errorSpan);
            } else {
              fileInput.insertAdjacentElement('afterend', errorSpan);
            }
          }
        }
        entityInput.classList.add('custom-missing-upload');
      } else {
        // Files present — clean up any previous error
        if (fileInput?.parentElement) {
          const errorSpan = fileInput.parentElement.querySelector<
            HTMLSpanElement
          >('.upload-required-error');
          if (errorSpan) errorSpan.remove();
        }
        hasMissingUploads = false;
        entityInput.classList.remove('custom-missing-upload');
      }
    });

    return hasMissingUploads;
  }

  private scrollToFirstInvalidField(index: number): void {
    setTimeout(() => {
      try {
        const wrapper = document.querySelectorAll(
          '.category-activity-container'
        )[index];
        if (!wrapper) return;

        const fieldWrappers = Array.from(
          wrapper.querySelectorAll<HTMLElement>(
            'wm-data-entity-input, wm-list-data-entity-input, wm-document-data-entity-input, wm-calculate-value-data-entity-input, wm-numeric-data-entity-input, wm-free-form-text-data-entity-input, wm-rich-text-data-entity-input'
          )
        );

        const firstInvalidField = fieldWrappers.find(field => {
          const hasError =
            field.classList.contains('ng-invalid') ||
            field.querySelector('.ng-invalid') !== null ||
            field.classList.contains('custom-missing-upload');

          if (!hasError) return false;

          // Skip hidden/collapsed fields
          const rect = field.getBoundingClientRect();
          const isVisible =
            rect.width > 0 && rect.height > 0 && field.offsetParent !== null;
          if (!isVisible) return false;

          // Skip upload fields that actually have files
          if (field.classList.contains('custom-missing-upload')) return true;
          const uploadedFiles = field.querySelectorAll(
            'wm-upload .list-group-item'
          );
          if (uploadedFiles.length > 0) return false;

          // Skip checkbox groups where at least one is checked
          const checkboxes = field.querySelectorAll<HTMLInputElement>(
            'input[type="checkbox"]'
          );
          if (checkboxes.length > 0) {
            const anyChecked = Array.from(checkboxes).some(cb => cb.checked);
            if (anyChecked) return false;
          }

          // Skip fields the user just filled (now valid)
          const justFilled = field.querySelector(
            'wm-common-radio.ng-valid, wm-common-textfield.ng-valid, wm-common-dropdown.ng-valid'
          );
          if (justFilled) return false;

          return true;
        });

        if (firstInvalidField) {
          try {
            firstInvalidField.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'nearest'
            });
          } catch {
            firstInvalidField.scrollIntoView();
          }

          const inputToFocus = firstInvalidField.querySelector<HTMLElement>(
            'input:not([type="hidden"]):not([disabled]), textarea:not([disabled]), select:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])'
          );

          if (inputToFocus) {
            try {
              inputToFocus.focus({ preventScroll: true });
            } catch {
              try {
                inputToFocus.focus();
              } catch {}
            }
          }
        }
      } catch (err) {}
    }, 150);
  }
  onSubmitButtonClick = (
    text: TemplateRef<any> | string,
    activity: Activity<ActivityModel>,
    index: number
  ) => {
    return {
      text: this.inlineApplicationDetails.activitiesBasedOnCategory[index]
        .isSubmitting
        ? text
        : this.inlineApplicationDetails.activitiesBasedOnCategory[index]
            .submitBtnTitle,
      onClick: () => {
        this.submitActivity(activity, index);
      }
    };
  };
  submitActivity = (
    activity: Activity<ActivityModel>,
    index: number,
    disableValidation: boolean = false
  ) => {
    this.validateAndPersistActivity(index, disableValidation).then(isValid => {
      if (!isValid) return;
      this.inlineApplicationDetails.activitiesBasedOnCategory[
        index
      ].isSubmitting = true;
      const decActivity = JsonNetDecycle.decycle(activity);
      const appId = this.isChildApplication
        ? this.childApplicationId
        : this.applicationId;
      this.workflowService
        .submitWorkflowActivity(appId, decActivity, false)
        .subscribe({
          next: response => {
            this.inlineApplicationDetails.fees = response.fees;
            this.inlineApplicationDetails.hasFees = response.hasFees;
            this.inlineApplicationDetails.currentActivity =
              response.nextActivity;

            // // When another activity remains, the inline application stays open.
            // // Silently refetch GetDepartmentApplications so the parent row's fee,
            // // sign-off, and inspection icons update immediately after processing.
            // // Completed applications already use the full rerun paths below.
            // if (response.nextActivity !== undefined) {
            //   this.workflowApplicationsJanusSvc.triggerTableRefresh();
            // }

            if (response.nextActivity === undefined) {
              const currentPage = this.route.snapshot.queryParamMap.get('p');
              const currentId = this.route.snapshot.queryParamMap.get('id');
              const source = this.route.snapshot.queryParamMap.get('s');
              // we are done with application
              if (this.isChildApplication) {
                // go back to parent application
                if (response.applicationId === currentId) {
                  // first parent
                  this.router.navigate([], {
                    relativeTo: this.route,
                    queryParams: {
                      p: currentPage,
                      s: source
                    },
                    queryParamsHandling: 'replace'
                  });
                  setTimeout(() => {
                    this.workflowApplicationsJanusSvc.setData({
                      ...this.workflowApplicationsJanusSvc.getData(),
                      reRunJanusApplicationDataTable: true
                    });
                    setTimeout(() => {
                      this.router.navigate([], {
                        relativeTo: this.route,
                        queryParams: {
                          p: currentPage,
                          s: source,
                          id: currentId
                        },
                        queryParamsHandling: 'replace'
                      });
                    }, 500);
                  }, 500);
                } else {
                  // sub parents
                  this.router.navigate([], {
                    relativeTo: this.route,
                    queryParams: {
                      p: currentPage,
                      s: source
                    },
                    queryParamsHandling: 'replace'
                  });
                  setTimeout(() => {
                    this.workflowApplicationsJanusSvc.setData({
                      ...this.workflowApplicationsJanusSvc.getData(),
                      reRunJanusApplicationDataTable: true
                    });
                    setTimeout(() => {
                      this.router.navigate([], {
                        relativeTo: this.route,
                        queryParams: {
                          p: currentPage,
                          s: source,
                          id: currentId,
                          cid: response.applicationId,
                          isChild: 1
                        },
                        queryParamsHandling: 'replace'
                      });
                    }, 500);
                  }, 500);
                }
              } else {
                // re-run the application
                this.workflowApplicationsJanusSvc.setData({
                  ...this.workflowApplicationsJanusSvc.getData(),
                  reRunJanusApplicationDataTable: true,
                  scrollToExpandedRow: true
                });
                this.router.navigate([], {
                  relativeTo: this.route,
                  queryParams: {
                    p: currentPage,
                    id: currentId,
                    showAppView: 0,
                    c: 'view-application',
                    s: source
                  },
                  queryParamsHandling: 'replace'
                });
                this.toastr.success('Application processed successfully');
              }

              return;
            }
            if (
              this.isChildApplication &&
              response.applicationId !== this.childApplicationId
            ) {
              const currentPage = this.route.snapshot.queryParamMap.get('p');
              const currentId = this.route.snapshot.queryParamMap.get('id');
              const source = this.route.snapshot.queryParamMap.get('s');
              if (response.applicationId === currentId) {
                this.router.navigate([], {
                  relativeTo: this.route,
                  queryParams: {
                    p: currentPage,
                    s: source
                  },
                  queryParamsHandling: 'replace'
                });
                setTimeout(() => {
                  this.workflowApplicationsJanusSvc.setData({
                    ...this.workflowApplicationsJanusSvc.getData(),
                    reRunJanusApplicationDataTable: true
                  });
                  setTimeout(() => {
                    this.router.navigate([], {
                      relativeTo: this.route,
                      queryParams: {
                        p: currentPage,
                        s: source,
                        id: currentId
                      },
                      queryParamsHandling: 'replace'
                    });
                  }, 500);
                }, 500);
              } else {
                this.router.navigate([], {
                  relativeTo: this.route,
                  queryParams: {
                    p: currentPage,
                    s: source
                  },
                  queryParamsHandling: 'replace'
                });
                setTimeout(() => {
                  this.workflowApplicationsJanusSvc.setData({
                    ...this.workflowApplicationsJanusSvc.getData(),
                    reRunJanusApplicationDataTable: true
                  });
                  setTimeout(() => {
                    this.router.navigate([], {
                      relativeTo: this.route,
                      queryParams: {
                        p: currentPage,
                        s: source,
                        id: currentId,
                        cid: response.applicationId,
                        isChild: 1
                      },
                      queryParamsHandling: 'replace'
                    });
                  }, 500);
                }, 500);
              }
              return;
            }
            if (response?.categoryActivities.length === 0) {
              this.toastr.error(
                'Failed to process the activity. Please try again.'
              );
              return;
            }

            this.inlineApplicationDetails.activitiesBasedOnCategory = response.categoryActivities.map(
              fetchedCategoryActivity => {
                let activityInstance = null;

                if (fetchedCategoryActivity?.activity) {
                  activityInstance = ActivityUtilities.convertActivitiesJsonToClasses(
                    [fetchedCategoryActivity.activity]
                  )[0];
                }

                return {
                  activity: {
                    ...fetchedCategoryActivity,
                    activity: activityInstance
                  },

                  form: activityInstance
                    ? new UntypedFormGroup(
                        ValidationService.createValidationGroup(
                          activityInstance
                        ),
                        {
                          updateOn: 'blur'
                        }
                      )
                    : new UntypedFormGroup({}),

                  isActivityAccordionOpen:
                    fetchedCategoryActivity?.status === 1 && activityInstance
                      ? true
                      : false,

                  isFetching: false,
                  errorFetching: '',
                  isSubmitting: false,
                  isSaving: false,

                  isActionRequired: fetchedCategoryActivity?.status === 1,

                  submitBtnTitle:
                    fetchedCategoryActivity?.status === 1 ? 'SUBMIT' : 'UPDATE',

                  showSaveBtn:
                    fetchedCategoryActivity?.activity?.showSaveButton ===
                      true && fetchedCategoryActivity?.status === 1
                      ? true
                      : false,

                  showSubmitButton:
                    fetchedCategoryActivity?.activity?.showProcessButton ===
                    true
                      ? true
                      : false
                };
              }
            );
            // check whether any in progress activities are left
            const updatedActivities = this.inlineApplicationDetails
              .activitiesBasedOnCategory;
            const hasInProgressActivities = updatedActivities.some(
              activity => activity.activity?.status === 1
            );
            // update active category
            if (hasInProgressActivities === false) {
              if (this.isChildApplication) {
                this.fetchCategoriesBasedOnApplicationId(
                  this.childApplicationId,
                  this.applicationDate,
                  1
                );
              } else {
                this.fetchCategoriesBasedOnApplicationId(
                  this.applicationId,
                  this.applicationDate,
                  this.inlineApplicationDetails.applicationStatusCode
                );
              }

              this.workflowApplicationsJanusSvc.setData({
                ...this.workflowApplicationsJanusSvc.getData(),
                scrollToExpandedRow: true
              });
              return;
            }
            this.inlineApplicationDetails.activeApplicationCategory.hasInProgressActivities = hasInProgressActivities;
            // update same flag in categories list
            const catIndex = this.inlineApplicationDetails.applicationCategories.findIndex(
              cat =>
                cat.id ===
                this.inlineApplicationDetails.activeApplicationCategory.id
            );

            if (catIndex >= 0) {
              this.inlineApplicationDetails.applicationCategories[
                catIndex
              ].hasInProgressActivities = hasInProgressActivities;
            }

            this.toastr.success('Activity processed successfully');
            this.workflowApplicationsJanusSvc.setData({
              ...this.workflowApplicationsJanusSvc.getData(),
              scrollToExpandedRow: true
            });
          },
          error: _err => {
            this.toastr.error(
              'Failed to process the activity. Please try again.'
            );
            this.workflowApplicationsJanusSvc.setData({
              ...this.workflowApplicationsJanusSvc.getData(),
              scrollToExpandedRow: true
            });
          }
        });
    });
  };

  onSaveButtonClick = (
    text: TemplateRef<any> | string,
    activity: Activity<ActivityModel>,
    index: number
  ) => {
    return {
      text: this.inlineApplicationDetails.activitiesBasedOnCategory[index]
        .isSaving
        ? text
        : 'SAVE',
      onClick: () => {
        this.saveActivity(activity, index);
      }
    };
  };
  saveActivity = (
    activity: Activity<ActivityModel>,
    index: number,
    reFetchCurrentActivity: boolean = false
  ) => {
    this.inlineApplicationDetails.activitiesBasedOnCategory[
      index
    ].isSaving = true;
    const decActivity = JsonNetDecycle.decycle(activity);
    const appId = this.isChildApplication
      ? this.childApplicationId
      : this.applicationId;
    this.workflowService
      .saveWorkflowActivity(appId, decActivity)
      .pipe(
        finalize(() => {
          this.inlineApplicationDetails.activitiesBasedOnCategory[
            index
          ].isSaving = false;
          this.workflowApplicationsJanusSvc.setData({
            ...this.workflowApplicationsJanusSvc.getData(),
            scrollToExpandedRow: true
          });
        })
      )
      .subscribe({
        next: response => {
          if (response.saveSuccess === true) {
            if (reFetchCurrentActivity === true) {
              this.fetchCurrentActivity(index);
            } else {
              this.toastr.success('Changes saved successfully');
            }
          } else {
            this.toastr.error('Failed to save changes. Please try again.');
          }
        },
        error: _err => {
          this.toastr.error('Failed to save changes. Please try again.');
        }
      });
  };
  onAttachmentsChanged(event: {
    applicationId: string;
    unreadAttachments: number;
    totalAttachments: number;
  }): void {
    this.attachmentChanged.emit(event);
  }

  onNotesChanged(event: {
    applicationId: string;
    unreadNotes: number;
    totalNotes: number;
  }): void {
    this.notesChanged.emit(event);
  }

  toggleAccordion(
    activity: ActivitiesBasedOnCategoryData,
    index: number
  ): void {
    if (activity.isActivityAccordionOpen) {
      this.inlineApplicationDetails.activitiesBasedOnCategory[
        index
      ].isActivityAccordionOpen = false;
      return;
    }

    if (
      this.inlineApplicationDetails.activitiesBasedOnCategory[index].activity
        ?.activity
    ) {
      this.inlineApplicationDetails.activitiesBasedOnCategory[
        index
      ].isActivityAccordionOpen = true;
    } else {
      this.fetchCurrentActivity(index);
    }
  }
  fetchCurrentActivity = (index: number) => {
    this.inlineApplicationDetails.activitiesBasedOnCategory[
      index
    ].isActivityAccordionOpen = true;

    this.inlineApplicationDetails.activitiesBasedOnCategory[
      index
    ].isFetching = true;

    const activityDataId = this.inlineApplicationDetails
      .activitiesBasedOnCategory[index].activity.activityDataId;
    const appId = this.isChildApplication
      ? this.childApplicationId
      : this.applicationId;
    this.workflowService
      .navigateToActivity(appId, activityDataId)
      .pipe(
        finalize(() => {
          this.inlineApplicationDetails.activitiesBasedOnCategory[
            index
          ].isFetching = false;
        })
      )
      .subscribe({
        next: response => {
          const activityInstance = ActivityUtilities.convertActivitiesJsonToClasses(
            [response.activity]
          )[0];

          if (!activityInstance) {
            this.inlineApplicationDetails.activitiesBasedOnCategory[index].errorFetching = 'Please complete the previous or dependent activity first to proceed with this one.';
            this.inlineApplicationDetails.activitiesBasedOnCategory[index].isFetching = false;
            return;
          }

          this.inlineApplicationDetails.activitiesBasedOnCategory[index] = {
            activity: {
              activityName: activityInstance.summaryLabel,
              activity: activityInstance,
              activityDataId: activityInstance?.activityDataId,
              activityId: activityInstance?.id
            },

            form: activityInstance
              ? new UntypedFormGroup(
                  ValidationService.createValidationGroup(activityInstance),
                  {
                    updateOn: 'blur'
                  }
                )
              : new UntypedFormGroup({}),

            isActivityAccordionOpen: true,

            isFetching: false,
            errorFetching: '',
            isSaving: false,
            isSubmitting: false,

            isActionRequired: activityInstance?.status === 1 ? true : false,

            submitBtnTitle:
              activityInstance?.status === 1 ? 'SUBMIT' : 'UPDATE',

            showSaveBtn:
              activityInstance?.showSaveButton === true &&
              activityInstance?.status === 1
                ? true
                : false,
            showSubmitButton:
              activityInstance?.showProcessButton === true ? true : false
          };

          this.inlineApplicationDetails.activitiesBasedOnCategory[
            index
          ].form = new UntypedFormGroup(
            ValidationService.createValidationGroup(activityInstance),
            { updateOn: 'blur' }
          );
        },
        error: () => {
          this.inlineApplicationDetails.activitiesBasedOnCategory[
            index
          ].errorFetching = 'error occured while fetching activity';
        }
      });
  };
  openShareActivity(
    activityDetails: ActivitiesBasedOnCategoryData,
    index: number,
    event: MouseEvent
  ): void {
    // Added by Amisha on 2026-08-12.
    // Reason: load the selected activity when necessary and share that activity specifically.
    event.stopPropagation();

    const loadedActivity = activityDetails.activity?.activity;
    if (loadedActivity) {
      this.openShareModalIfAllowed(loadedActivity);
      return;
    }

    const activityDataId = activityDetails.activity?.activityDataId;
    if (!activityDataId || this.sharingActivityDataId) {
      return;
    }

    this.sharingActivityDataId = activityDataId;
    this.workflowService
      .navigateToActivity(this.applicationId, activityDataId)
      .pipe(finalize(() => (this.sharingActivityDataId = null)))
      .subscribe({
        next: response => {
          const activity = ActivityUtilities.convertActivitiesJsonToClasses([
            response.activity
          ])[0];

          this.inlineApplicationDetails.activitiesBasedOnCategory[
            index
          ].activity.activity = activity;
          this.inlineApplicationDetails.activitiesBasedOnCategory[
            index
          ].form = new UntypedFormGroup(
            ValidationService.createValidationGroup(activity),
            { updateOn: 'blur' }
          );

          this.openShareModalIfAllowed(activity);
        },
        error: () => {
          this.toastr.error(
            'Unable to load this activity for sharing. Please try again.'
          );
        }
      });
  }

  private openShareModalIfAllowed(activity: Activity<ActivityModel>): void {
    if (!activity.canBeShared) {
      this.toastr.info('This activity cannot be shared.');
      return;
    }

    this.shareActivityComponent.open(activity);
  }
}
